import React from 'react'
import { GoMarkGithub} from 'react-icons/go'
import { BsLinkedin } from 'react-icons/bs'
import { BsFillFileEarmarkPdfFill } from 'react-icons/bs'
import { SiGmail } from 'react-icons/si'
import resume from '../files/resume.pdf'
import { Link } from 'react-router-dom'
function About() {
  const hover = 'hover:text-[#ffff00] transition-all';
  return (
    <div className='about'
    >
        <h2 className='text-4xl font-semibold mb-4'>About Me : </h2>
        <p>I am Habibur Rahman Meheraj, <span className='text-[#ffff00] font-semibold'>Junior Front-End Developer</span> Experience with React js for the Front-End and Node Express Js I use for BackEnd Development. As a Database to store data in the MongoDB. I want to create my carrier in Software Industry. I am curious to know something new in my life. Exploring is my passion.</p>
        <div className="my-[40px] text-4xl w-full flex justify-center items-center gap-[15px]">
        <a className={hover} target={"_blank"} href='mailto:habib.meheraj@gmail.com'><SiGmail/></a>
        <a className={hover}  target={"_blank"}   href='https://linkedin.com/in/habib-meheraj'><BsLinkedin/></a>
        <a className={hover} target={"_blank"}  href='https://github.com/hr-meheraj'><GoMarkGithub/></a>
        <a className={hover}  href={resume} target={"_blank"} download={"habibur-rahman-resume"}><BsFillFileEarmarkPdfFill/></a>
        </div>
    </div>
  )
}

export default About